
<router-outlet></router-outlet>
<div [hidden]=!main.blockUI style="width: 100%; height: 100%; top: 0px; right: 0px; z-index: 9999; position: fixed; text-align: center; background:rgba(0,0,0,0.3);">
    <div id="loader">
        <img src="assets/img/loader-preview.svg" alt="loading" width="50" style="padding-top: 30px;">
    </div>
</div>